/** @format */

import Request from 'utils/request';
import Cookie from 'js-cookie';

export default class ProductListServ {
  static getBiz(params) {
    return Request({
      method: 'get',
      url: `api/basicdata/v1/biz-space`,
      data: params
    });
  }
  static getAppList(params) {
    return Request({
      url: `api/user/v1/application/tenant/${Cookie.get('tenant_id')}/instances`,
      method: 'GET',
      data: params
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/ProductList/ProductListServ.js